module.exports = __webpack_public_path__ + "static/media/krx-devices.9b44214e.jpg";